// test2146
(2146 && 0);
